import { Box, Slider, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { formatCurrency } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import { INSPIRATION_CURRENCY } from "web_myplann/Inspiration/constants";

type Props = {
	label: string;
	value: number;
	onChange: (value: number) => void;
	min: number;
	max: number;
	step: number;
	hint?: string;
};

export const BoxedSliderField: FC<Props> = ({
	label,
	value,
	onChange,
	min,
	max,
	step,
	hint,
}) => {
	const theme = useTheme();
	return (
		<Box
			bgcolor={theme.palette.surface.muted}
			borderRadius={theme.radii.lg}
			p={1.2}
		>
			<Stack direction="row" alignItems="center" justifyContent="space-between">
				<Typography variant="bodyMedium">{label}</Typography>
				<Typography variant="subtitle3" color={theme.palette.blue.main} tabular>
					{formatCurrency(value, INSPIRATION_CURRENCY, 0)}
				</Typography>
			</Stack>
			<Slider
				variant="flat"
				value={value}
				onChange={(_, v) => onChange(Array.isArray(v) ? v[0] : v)}
				min={min}
				max={max}
				step={step}
				style={{ height: 30, padding: 0 }}
				sx={{ mt: 0.4 }}
			/>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="hint" tabular>
					{formatCurrency(min, INSPIRATION_CURRENCY, 0)}
				</Typography>
				<Typography variant="hint" tabular>
					{formatCurrency(max, INSPIRATION_CURRENCY, 0)}
				</Typography>
			</Stack>
			{hint && (
				<Typography
					variant="hint"
					color={theme.palette.grey[500]}
					mt={0.8}
					display="block"
				>
					{hint}
				</Typography>
			)}
		</Box>
	);
};
